import ItemCard from '../components/ItemCard';
import { CssBaseline, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Slider from 'react-slick';

import { BaseAPI } from '../utils/Api';
import LoadingState from '../components/Controls/LoadingState';
import Page from '../components/Controls/Page';
import { getItem } from '../utils/Helper';
import ErrorHandler from '../utils/ErrorHandler';
import Notification from '../utils/Notification';
import { useNavigate } from 'react-router-dom';
import { isValidToken } from '../utils/Jwt';

import cover from '../assets/images/cover.png';

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const Home = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [trendingDataset, setTrendingDataset] = useState([]);
  const [newlyUploadedDataset, setNewlyUploadedDataset] = useState([]);

  useEffect(() => {
    getHomeDatasets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getHomeDatasets = () => {
    setLoading(true);
    const getId = getItem(localStorage, 'un') || null;
    const getNewlyUploadedDataset = BaseAPI.get(`/dataset/newly-uploaded?user_id=${getId}`);
    const getTrendingDataset = BaseAPI.get(`/dataset/trending-datasets?user_id=${getId}`);

    Promise.all([getNewlyUploadedDataset, getTrendingDataset])
      .then((res) => {
        setNewlyUploadedDataset(res[0].data.data);
        setTrendingDataset(res[1].data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ErrorHandler(err?.response?.data?.message, navigate);
        } else {
          Notification('Something went wrong!', 'error');
        }
      })
      .finally(() => setLoading(false));
  };

  const handleWishList = (data) => {
    const getToken = getItem(localStorage, 'at');

    if (localStorage.getItem('at') && isValidToken(getToken)) {
      BaseAPI.post('/dataset/wishlist', { dataset_url: data }, { headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` } })
        .then(() => {
          getHomeDatasets();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      Notification('Please login first', 'error');
    }
  };

  const handleCart = (data) => {
    const getToken = getItem(localStorage, 'at');

    if (localStorage.getItem('at') && isValidToken(getToken)) {
      BaseAPI.post('/dataset/cartlist', { dataset_url: data }, { headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` } })
        .then((res) => {
          getHomeDatasets();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      Notification('Please login first', 'error');
    }
  };

  return (
    <Page title='Home'>
      {/* TODO: Need to add sick image for carousel */}
      <CssBaseline />
      <LoadingState loading={loading} />

      <Grid container spacing={8}>
        <Grid item xs={12}>
          <Slider {...settings}>
            <img src={cover} height='100%' width='100%' alt='cover' />
            <img src={cover} height='100%' width='100%' alt='cover' />
          </Slider>
        </Grid>
      </Grid>
      {/* newly uploaded data cards */}
      <Typography variant='h5' mt={2} mb={4} className='bold'>
        Newly Uploaded
      </Typography>
      <Grid container spacing={2} mb={6}>
        {newlyUploadedDataset?.map((el) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={el.url_name}>
            <ItemCard
              link={el.url_name}
              image={el.image}
              category={el.category}
              name={el.name}
              price={el.price}
              discount={el.discount}
              rows={el.data_rows}
              handleCart={handleCart}
              handleWishList={handleWishList}
              isCart={el.is_cart}
              isWish={el.is_wish}
            />
          </Grid>
        ))}
      </Grid>
      {/* trending data cards */}
      <Typography variant='h5' mt={2} mb={4} className='bold'>
        Trending Datasets
      </Typography>
      <Grid container spacing={2} mb={6}>
        {trendingDataset?.map((el) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={el.url_name}>
            <ItemCard
              link={el.url_name}
              image={el.image}
              category={el.category}
              name={el.name}
              price={el.price}
              discount={el.discount}
              rows={el.data_rows}
              handleCart={handleCart}
              handleWishList={handleWishList}
              isCart={el.is_cart}
              isWish={el.is_wish}
            />
          </Grid>
        ))}
      </Grid>
    </Page>
  );
};

export default Home;
